exports = module.exports = require("../../../../node_modules/_css-loader@0.23.1@css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".engine-insertion-ghost{height:0}.engine-dragging{filter:blur(2px) brightness(.6)}.engine-unknow-component{background:var(--color-function-information-light,#66a8d4)}.engine-fault-component,.engine-unknow-component{padding:15px;color:var(--color-text-reverse,hsla(0,0%,100%,.8));font-size:18px;text-align:center}.engine-fault-component{background:var(--color-function-error-dark,#ae1e0d)}.engine-hidden-component{background:var(--color-function-information,#2e76a6);padding:5px;color:var(--color-text-reverse,hsla(0,0%,100%,.8));font-size:16px;text-align:center;font-style:italic}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/_css-loader@0.23.1@css-loader!./~/_less-loader@2.2.3@less-loader!./lib/engine/ui/placeholders/index.less
// module id = 28
// module chunks = 0